import { render, staticRenderFns } from "./NftGrid.vue?vue&type=template&id=387f10dc&scoped=true&"
import script from "./NftGrid.vue?vue&type=script&lang=js&"
export * from "./NftGrid.vue?vue&type=script&lang=js&"
import style0 from "./NftGrid.vue?vue&type=style&index=0&id=387f10dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387f10dc",
  null
  
)

export default component.exports